import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "diamonds-mobile-search-form w-full px-4 py-6 bg-white border-b border-gray-100" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center mb-10"
}
const _hoisted_3 = { class: "relative bg-gray-100 p-1 rounded-xl flex w-full shadow-inner" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex gap-2 items-center" }
const _hoisted_6 = { class: "font-bold text-sm text-gray-900 tracking-tight uppercase" }
const _hoisted_7 = { class: "text-sm text-gray-500 font-light" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = {
  key: 0,
  class: "w-1.5 h-1.5 rounded-full bg-brand-main"
}
const _hoisted_10 = {
  key: 1,
  class: "flex gap-2 items-center mb-4"
}
const _hoisted_11 = { class: "font-bold text-sm text-gray-900 tracking-tight uppercase" }
const _hoisted_12 = { class: "text-sm text-gray-500 font-light" }
const _hoisted_13 = { class: "mobile-filter-content" }
const _hoisted_14 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_15 = {
  key: 4,
  class: "mt-6 overflow-x-auto no-scrollbar scroll-smooth"
}
const _hoisted_16 = { class: "flex gap-8 pb-4 px-2 h-32" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = {
  key: 1,
  class: "mt-8 pt-8 border-t border-gray-200 flex flex-wrap items-center justify-between gap-6"
}
const _hoisted_20 = { class: "flex items-center gap-3" }
const _hoisted_21 = { class: "flex items-center gap-3" }
const _hoisted_22 = { class: "text-[13px] uppercase tracking-widest text-[#4A5568]" }

import { ref, computed } from "vue";
import DiamondsSearchFormIcons from "@/components/diamonds/form/diamondsSearchFormIcons.vue";
import DiamondsSearchFormNumberRange from "@/components/diamonds/form/diamondsSearchFormNumberRange.vue";
import DiamondsSearchFormRange from "@/components/diamonds/form/diamondsSearchFormRange.vue";
import DiamondsSearchFormSwitch from "@/components/diamonds/form/diamondsSearchFormSwitch.vue";
import DiamondsSearchFormList from "@/components/diamonds/form/diamondsSearchFormList.vue";
import DiamondsSearchFormPresets from "@/components/diamonds/form/diamondsSearchFormPresets.vue";
import { getActiveValueLabelShared } from "@/assets/ts/diamondFilters";
import DiamondsSearchFormTextList from "@/components/diamonds/form/diamondsSearchFormTextList.vue";
import InfoModal from "@/components/info/infoModal.vue";
import {useI18n} from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsMobileSearchForm',
  props: {
    filters: {},
    activeFilters: {},
    simpleFilterKeys: { default: () => ['type', 'size', 'form'] },
    searchMode: { default: 'simple' },
    presets: { default: () => [] }
  },
  emits: ["update:filters", "updateFilters", "update:searchMode"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n();

const props = __props;

const indicatorRefs = ref<Record<string, any>>({});

__expose({
  indicatorRefs
});

const emit = __emit;

const internalSearchMode = ref<'simple' | 'pro'>(props.searchMode);
const searchMode = computed({
  get: () => props.searchMode || internalSearchMode.value,
  set: (val: 'simple' | 'pro') => {
    internalSearchMode.value = val;
    emit('update:searchMode', val);
  }
});

const manualExpanded = ref<Record<string, boolean>>({});

const switchToSimple = () => {
  searchMode.value = 'simple';
  const newFilters = { ...props.activeFilters };
  const simpleKeys = props.simpleFilterKeys || ['type', 'size', 'form'];

  Object.keys(props.filters).forEach(key => {
    if (!simpleKeys.includes(key)) {
      newFilters[key] = props.filters[key].default !== undefined ? props.filters[key].default : null;
    }
  });

  emit("update:filters", newFilters);
};

const updateFilter = (key: string, value: any) => {
  const newFilters = { ...props.activeFilters };
  const filter = props.filters[key];

  let parsedValue = value;
  if (filter.type === 'bool') {
    if (value === 'true') parsedValue = true;
    else if (value === 'false') parsedValue = false;
  }

  const oldValue = newFilters[key];

  if (filter.type === 'text' && filter.view === 'list') {
    newFilters[key] = value;
  } else if (newFilters[key] === parsedValue) {
    newFilters[key] = filter.default !== undefined ? filter.default : null;
  } else {
    newFilters[key] = parsedValue;
  }

  // Special rule sets (copied from diamondsSearchForm.vue)
  if (key === 'type' && oldValue === 'earth' && newFilters.type === 'lab') {
    newFilters.institute = [];
    newFilters.color = ["E", "D"];
    newFilters.clarity = ["VS2", "VS1", "VVS2", "VVS1", "IF", "FL"];
  }

  if (key === 'type' && oldValue === 'lab' && newFilters.type === 'earth' && newFilters.colored === true) {
    newFilters.colored = false;
    newFilters.color = [];
    newFilters.fancy_intensity = [];
  }

  if (key === 'colored' && (oldValue === false || oldValue == null) && newFilters.colored === true) {
    newFilters.type = "lab";
    newFilters.clarity = [];
    newFilters.color = [];
    newFilters.cut = [];
    newFilters.polish = [];
    newFilters.fancy_intensity = [];
    newFilters.symmetry = [];
    newFilters.fluorescence = [];
    newFilters.institute = [];
    newFilters.fastDelivery = false;
  }

  if (key === 'form' && newFilters.form !== "BR") {
    newFilters.cut = [];
  }

  emit("update:filters", newFilters);
};

const sizeSteps = [0.3, 0.4, 0.5, 0.7, 1.0, 1.5, 2.0, 2.5, 3.0];
const filteredSizeSteps = computed(() => {
  const min = props.filters.size?.min ?? 0;
  const max = props.filters.size?.max ?? 10;
  return sizeSteps.filter(s => s >= min && s <= max);
});

const getDiamondImageUrl = (form: string) => {
  const formFilter = props.filters['form'];
  if (!formFilter || !formFilter.image) return "";
  const processedVal = formFilter.lowercaseImage !== false ? form.toLowerCase() : form;
  return formFilter.image.replace("{value}", processedVal);
};

const activeForm = computed(() => {
  return props.activeFilters['form'] || props.filters['form']?.default || 'BR';
});

const isFilterDefined = (key: string) => {
  const filter = props.filters[key];
  const active = props.activeFilters[key];
  if (!active) return false;
  // Handle objects (like carat or price range)
  if (typeof active === 'object' && filter.default && typeof filter.default === 'object') {
    return active.min !== filter.default.min || active.max !== filter.default.max;
  }
  if (Array.isArray(active) && Array.isArray(filter.default)) {
    return active.length !== filter.default.length || !active.every((v, i) => v === filter.default[i]);
  }
  if (filter.default && active === filter.default) return false;
  return true;
};

const isAlwaysVisible = (key: string) => {
  if (searchMode.value === 'simple') return true;
  return key === 'type';
}

const isFilterOpen = (key: string) => {
  if (isAlwaysVisible(key)) return true;
  if (isFilterDefined(key)) return true;
  if (manualExpanded.value[key] !== undefined) {
    return manualExpanded.value[key];
  }
  return props.filters[key]?.visible || false;
};

const toggleFilter = (key: string) => {
  if (isFilterDefined(key)) return;
  manualExpanded.value[key] = !isFilterOpen(key);
};

const sortedFilterKeys = computed(() => {
  const keys = Object.keys(props.filters)
    .filter(key => {
      if (key === 'sortOrder' || key === 'sort' || key === 'colored') return false;
      if (key === 'fancy_intensity' && !props.activeFilters.colored) return false;
      
      if (searchMode.value === 'simple') {
        return props.simpleFilterKeys?.includes(key);
      }
      
      return true;
    });

  return keys.sort((a, b) => {
    return (props.filters[a].order || 0) - (props.filters[b].order || 0);
  });
});

const getFilterLabel = (key: string) => {
  return t('components.diamonds.search.labels.' + key);
};

const getActiveValueLabel = (key: string, value: any) => {
  return getActiveValueLabelShared(key, value, props.filters, props.activeFilters);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "absolute top-1 bottom-1 w-[calc(50%-4px)] bg-white rounded-lg shadow-sm transition-all duration-300 ease-out transform",
              style: _normalizeStyle({ left: searchMode.value === 'pro' ? 'calc(50% + 2px)' : '4px' })
            }, null, 4),
            _createElementVNode("button", {
              type: "button",
              onClick: switchToSimple,
              class: _normalizeClass(["relative flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold transition-colors duration-200 z-10", searchMode.value === 'simple' ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'])
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "w-4 h-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M4 6h16M4 12h16m-7 6h7"
                })
              ], -1),
              _createTextVNode(" Einfach ", -1)
            ]))], 2),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (searchMode.value = 'pro')),
              class: _normalizeClass(["relative flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold transition-colors duration-200 z-10", searchMode.value === 'pro' ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'])
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "w-4 h-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                })
              ], -1),
              _createTextVNode(" Pro ", -1)
            ]))], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedFilterKeys.value, (key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        ref_for: true,
        ref: el => { if (el) indicatorRefs.value[key] = el },
        class: "mb-8 last:mb-0 scroll-mt-4"
      }, [
        (!isAlwaysVisible(key))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: ($event: any) => (toggleFilter(key)),
              class: "w-full flex justify-between items-center py-2 mb-2 group"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, _toDisplayString(getFilterLabel(key)) + ":", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(getActiveValueLabel(key, __props.activeFilters[key])), 1),
                _createVNode(InfoModal, {
                  id: __props.filters[key].modalId,
                  value: __props.activeFilters[key]
                }, null, 8, ["id", "value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (isFilterDefined(key))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                  : _createCommentVNode("", true),
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(["w-4 h-4 text-gray-400 transition-transform duration-300", { 'rotate-180': isFilterOpen(key) }]),
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ]))], 2))
              ])
            ], 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h3", _hoisted_11, _toDisplayString(getFilterLabel(key)) + ":", 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(getActiveValueLabel(key, __props.activeFilters[key])), 1),
              _createVNode(InfoModal, {
                id: __props.filters[key].modalId,
                value: __props.activeFilters[key]
              }, null, 8, ["id", "value"])
            ])),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          (key === 'color' && __props.filters.colored)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(DiamondsSearchFormSwitch, {
                  filter: __props.filters.colored,
                  "active-value": __props.activeFilters.colored,
                  onUpdate: _cache[1] || (_cache[1] = (val) => updateFilter('colored', val))
                }, null, 8, ["filter", "active-value"])
              ]))
            : _createCommentVNode("", true),
          (key === 'color' && __props.activeFilters.colored)
            ? (_openBlock(), _createBlock(DiamondsSearchFormList, {
                key: 1,
                class: "mobile-list-grid",
                filter: {...__props.filters[key], values: __props.filters[key].fancy_colors},
                "active-value": __props.activeFilters[key],
                onUpdate: (val) => updateFilter(key, val)
              }, null, 8, ["filter", "active-value", "onUpdate"]))
            : (__props.filters[key].type === 'icon' && __props.filters[key].view === 'list')
              ? (_openBlock(), _createBlock(DiamondsSearchFormIcons, {
                  key: 2,
                  class: "mobile-list-grid",
                  filter: __props.filters[key],
                  "active-value": __props.activeFilters[key],
                  onUpdate: (val) => updateFilter(key, val)
                }, null, 8, ["filter", "active-value", "onUpdate"]))
              : (__props.filters[key].type === 'number' && __props.filters[key].view === 'range' && (key !== 'size' || searchMode.value === 'pro'))
                ? (_openBlock(), _createBlock(DiamondsSearchFormNumberRange, {
                    key: 3,
                    filter: __props.filters[key],
                    "active-value": __props.activeFilters[key],
                    onUpdate: (val) => updateFilter(key, val)
                  }, null, 8, ["filter", "active-value", "onUpdate"]))
                : (key === 'size' && searchMode.value === 'simple')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSizeSteps.value, (s) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: s,
                            class: "flex flex-col justify-center items-center cursor-pointer min-w-fit",
                            onClick: ($event: any) => (updateFilter(key, {min: s, max: s}))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-16 h-16 overflow-hidden rounded-full flex items-center justify-center mb-2 transition-all duration-300 relative bg-white", __props.activeFilters[key] && __props.activeFilters[key].min === s && __props.activeFilters[key].max === s
                    ? 'shadow-md w-20 h-20'
                    : ''])
                            }, [
                              _createElementVNode("div", {
                                class: "transition-transform duration-500 ease-out",
                                style: _normalizeStyle({ transform: `scale(${0.4 + (s / 3) * 0.6})` })
                              }, [
                                _createElementVNode("img", {
                                  src: getDiamondImageUrl(activeForm.value),
                                  alt: activeForm.value,
                                  class: "w-18 h-18 object-contain opacity-80"
                                }, null, 8, _hoisted_18)
                              ], 4)
                            ], 2),
                            _createElementVNode("span", {
                              class: _normalizeClass(["text-sm text-gray-500 tracking-wide whitespace-nowrap transition-all duration-300", __props.activeFilters[key] && __props.activeFilters[key].min === s && __props.activeFilters[key].max === s ? 'font-bold' : ''])
                            }, _toDisplayString(s.toLocaleString('de-DE', { minimumFractionDigits: 1 })) + " ct. ", 3)
                          ], 8, _hoisted_17))
                        }), 128))
                      ])
                    ]))
                  : ((__props.filters[key].type === 'icon' || __props.filters[key].type === 'text') && __props.filters[key].view === 'range')
                    ? (_openBlock(), _createBlock(DiamondsSearchFormRange, {
                        key: 5,
                        filter: __props.filters[key],
                        "active-value": __props.activeFilters[key],
                        onUpdate: (val) => updateFilter(key, val)
                      }, null, 8, ["filter", "active-value", "onUpdate"]))
                    : ((__props.filters[key].type === 'text' || __props.filters[key].type === 'bool') && __props.filters[key].view === 'switch')
                      ? (_openBlock(), _createBlock(DiamondsSearchFormSwitch, {
                          key: 6,
                          filter: __props.filters[key],
                          "active-value": __props.activeFilters[key],
                          onUpdate: (val) => updateFilter(key, val)
                        }, null, 8, ["filter", "active-value", "onUpdate"]))
                      : (__props.filters[key].type === 'text' && __props.filters[key].view === 'list')
                        ? (_openBlock(), _createBlock(DiamondsSearchFormTextList, {
                            key: 7,
                            class: "mobile-list-grid",
                            filter: __props.filters[key],
                            "active-value": __props.activeFilters[key],
                            onUpdate: (val) => updateFilter(key, val)
                          }, null, 8, ["filter", "active-value", "onUpdate"]))
                        : _createCommentVNode("", true)
        ], 512), [
          [_vShow, isFilterOpen(key)]
        ]),
        (key === 'type' && __props.presets && __props.presets.length > 0 && (typeof __props.activeFilters.colored == 'undefined' || __props.activeFilters.colored !== true))
          ? (_openBlock(), _createBlock(DiamondsSearchFormPresets, {
              key: 2,
              presets: __props.presets,
              "active-filters": __props.activeFilters,
              class: "mt-6 mb-10",
              onUpdateFilters: _cache[2] || (_cache[2] = (val) => {
          emit('updateFilters', val);
          emit('update:filters', val);
        })
            }, null, 8, ["presets", "active-filters"]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (updateFilter('fastDelivery', !__props.activeFilters.fastDelivery))),
              class: "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none",
              style: _normalizeStyle({ backgroundColor: __props.activeFilters.fastDelivery ? '#a99d8b' : '#e5e7eb' })
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out", __props.activeFilters.fastDelivery ? 'translate-x-5' : 'translate-x-0'])
              }, null, 2)
            ], 4),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-[13px] uppercase tracking-widest text-[#4A5568]" }, "Fast-Delivery", -1))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (updateFilter('sortOrder', __props.activeFilters.sortOrder === 'asc' ? 'desc' : 'asc'))),
              class: "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none",
              style: { backgroundColor: '#a99d8b' }
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out", __props.activeFilters.sortOrder === 'desc' ? 'translate-x-5' : 'translate-x-0'])
              }, null, 2)
            ]),
            _createElementVNode("span", _hoisted_22, "Sort: " + _toDisplayString(__props.activeFilters.sortOrder === 'asc' ? 'Auf' : 'Ab'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})